/** @jsx jsx */
import { jsx, css, Theme } from '@emotion/react'
import { memo } from 'react'
import { Viewer, ViewerProps } from '@react-pdf-viewer/core'
import { createThumbnailPlugin } from './CustomPlugins'

import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import { Box } from '@mui/material'

const PdfThumbnail = memo(function PdfThumbnail({
  src,
  coverIndex = 0,
}: {
  src: ViewerProps['fileUrl']
  coverIndex?: number
}) {
  const plugins = createThumbnailPlugin(coverIndex)
  return (
    <Box
      css={(theme: Theme) => css`
        & .rpv-thumbnail__cover-image {
          border: 1px solid ${theme.custom.palette.grey[54]};
        }
      `}
    >
      <Viewer fileUrl={src} plugins={plugins} />
    </Box>
  )
})

export default PdfThumbnail
